import * as React from "react";
import { useStorageIdentity } from "./storageIdentity";
import { createActivationTracker } from "./activationTelemetry";

export function useActivationTelemetry() {
  const identity = useStorageIdentity();
  return React.useMemo(() => createActivationTracker(identity),
    [identity.customerId, identity.orgId, identity.tenantId, identity.userId]);
}

export function DashboardEntryTelemetry(): null {
  const tracker = useActivationTelemetry();
  React.useEffect(() => tracker.entered(), [tracker]);
  return null;
}
